(function () {
  var root = document.querySelector('[data-swx-steps]');
  if (!root || root.dataset.swxReady) return;
  root.dataset.swxReady = '1';

  var stage = root.querySelector('[data-sxs-stage]');
  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-sxs-step]'));
  var prog = root.querySelector('[data-sxs-prog]');
  var timerEl = root.querySelector('[data-sxs-timer]');
  var holdEl = root.querySelector('[data-sxs-hold]');
  var track = root.querySelector('.sxs__track');
  var n = steps.length || 1;
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };

  var cur = -1, local = 0, threeTick = null;

  function setStep(i) {
    if (i === cur) return;
    cur = i;
    steps.forEach(function (s, k) { s.classList.toggle('is-on', k === i); s.classList.toggle('is-done', k < i); });
    var act = steps[i] ? steps[i].dataset.act : 'charge';
    stage.className = stage.className.replace(/\bis-\w+\b/g, '').trim() + ' is-' + act;
    root.querySelectorAll('[data-sxs-fb]').forEach(function (im) { im.classList.toggle('is-on', +im.dataset.sxsFb === i); });
  }

  function onScroll() {
    var r = track.getBoundingClientRect();
    var stick = track.firstElementChild;
    var hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sxh-h')) || 0;
    var total = track.offsetHeight - stick.offsetHeight;
    var p = total > 0 ? clamp((hh - r.top) / total, 0, 0.9999) : 0;
    var f = p * n;
    var i = Math.floor(f);
    local = f - i;
    setStep(i);
    if (prog) prog.style.transform = 'scaleY(' + ((i + local) / n + 0.0001).toFixed(4) + ')';
    if (timerEl) { var s = Math.round(1200 * (1 - local)); timerEl.textContent = Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); }
    stage.style.setProperty('--loc', local.toFixed(3));
    if (holdEl) holdEl.textContent = Math.max(0, Math.ceil(15 * (1 - local))) + 's';
    if (threeTick) threeTick();
  }
  steps.forEach(function (s, k) {
    s.addEventListener('click', function () {
      var top = track.getBoundingClientRect().top + window.scrollY;
      var total = track.offsetHeight - track.firstElementChild.offsetHeight;
      var hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sxh-h')) || 0;
      window.scrollTo({ top: top - hh + total * ((k + 0.35) / n), behavior: 'smooth' });
    });
  });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  function boot() {
    window.swxLoad3D(root).then(init3D).catch(function () { root.classList.add('sxs--no3d'); });
  }
  if ('IntersectionObserver' in window) {
    var lo = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { lo.disconnect(); boot(); } }, { rootMargin: '600px 0px' });
    lo.observe(root);
  } else boot();

  function glowTex(rgb) {
    var c = document.createElement('canvas'); c.width = c.height = 64;
    var g = c.getContext('2d'), gr = g.createRadialGradient(32, 32, 0, 32, 32, 32);
    gr.addColorStop(0, 'rgba(' + rgb + ',1)'); gr.addColorStop(0.35, 'rgba(' + rgb + ',.55)'); gr.addColorStop(1, 'rgba(' + rgb + ',0)');
    g.fillStyle = gr; g.fillRect(0, 0, 64, 64);
    return new THREE.CanvasTexture(c);
  }

  function init3D(gltf) {
    var canvas = root.querySelector('[data-swx-canvas]');
    var renderer;
    try { renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true }); }
    catch (e) { root.classList.add('sxs--no3d'); return; }
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.5));
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.1;

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(30, 1, 0.1, 200);
    camera.position.set(0, 1.1, 11);
    camera.lookAt(0, 0, 0);
    var pmrem = new THREE.PMREMGenerator(renderer);
    scene.environment = pmrem.fromScene(new THREE.RoomEnvironment(), 0.04).texture;
    scene.add(new THREE.HemisphereLight(0xdfe9ff, 0x0a0e18, 0.35));
    var key = new THREE.DirectionalLight(0xffffff, 2.2); key.position.set(5, 8, 6); scene.add(key);
    var rim = new THREE.DirectionalLight(0x2fe39b, 1.8); rim.position.set(-4, 5, -6); scene.add(rim);

    var HINGE = new THREE.Vector3(0, 0.13, -0.995), LID_CLOSED = 2.007;
    var model = gltf.scene.clone(true);
    var lid = model.getObjectByName('BoFsEvBGaAjKkRU');
    var body = model.getObjectByName('zzBtSmxeDxAZRRE');
    var budR = model.getObjectByName('szusrxTxeDnOCPF');
    var budL = model.getObjectByName('iauArCIBpqmQwBK');
    model.traverse(function (o) { if (o.isMesh && o.material) o.material.envMapIntensity = 1.25; });
    model.updateMatrixWorld(true);
    var b = new THREE.Box3().setFromObject(model), sz = b.getSize(new THREE.Vector3());
    model.scale.setScalar(3.2 / Math.max(sz.x, sz.y, sz.z));
    model.updateMatrixWorld(true);
    b = new THREE.Box3().setFromObject(model);
    model.position.sub(b.getCenter(new THREE.Vector3()));
    model.updateMatrixWorld(true);

    var rig = new THREE.Group(); scene.add(rig);
    rig.add(model);
    var lidPivot = new THREE.Group();
    lidPivot.position.copy(model.localToWorld(HINGE.clone()));
    rig.add(lidPivot); lidPivot.attach(lid);
    rig.attach(budL); rig.attach(budR);
    var budL0 = budL.position.clone(), budR0 = budR.position.clone();

    var bb = new THREE.Box3().setFromObject(body);
    var bsz = bb.getSize(new THREE.Vector3()), bc = bb.getCenter(new THREE.Vector3());
    var led = new THREE.Sprite(new THREE.SpriteMaterial({ map: glowTex('255,255,255'), color: 0xffffff, transparent: true, depthWrite: false, blending: THREE.AdditiveBlending }));
    led.position.set(bc.x, bb.max.y - bsz.y * 0.22, bb.max.z + 0.02);
    led.scale.setScalar(0.32); rig.add(led);
    var btn = new THREE.Sprite(new THREE.SpriteMaterial({ map: glowTex('47,227,155'), transparent: true, depthWrite: false, blending: THREE.AdditiveBlending }));
    btn.position.set(bc.x, bb.min.y + bsz.y * 0.3, bb.min.z - 0.02);
    btn.scale.setScalar(0.5); rig.add(btn);

    var TARGET = {
      charge: { ry: 0.45, lid: 0, buds: 0, x: 0, led: [0.2, 1, 0.55], ledA: 0.7, btn: 0 },
      open: { ry: 0.25, lid: 1, buds: 0, x: 0, led: [1, 1, 1], ledA: 1, flash: 1, btn: 0 },
      button: { ry: Math.PI - 0.35, lid: 1, buds: 0, x: 0, led: [1, 0.7, 0.2], ledA: 1, btn: 1, amber: 1 },
      forget: { ry: 0.6, lid: 1, buds: 0, x: -1.05, led: [1, 1, 1], ledA: 0.8, flash: 1, btn: 0 },
      connect: { ry: 0.15, lid: 1, buds: 1, x: 0, y: 0.75, led: [0.2, 1, 0.55], ledA: 0.9, btn: 0 },
      help: { ry: 0.0, lid: 0.55, buds: 0.35, x: 0, led: [0.2, 1, 0.55], ledA: 0.4, btn: 0, spin: 1 }
    };
    var S = { ry: 0.45, lid: 0, buds: 0, x: 0, y: 0, ledA: 0, btn: 0 };
    var mobile = false, visible = true, running = false, t0 = performance.now();

    function resize() {
      var w = canvas.clientWidth, h = canvas.clientHeight;
      if (!w || !h) return;
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      mobile = w < 640;
      camera.position.z = mobile ? 12.5 : 11;
      camera.updateProjectionMatrix();
    }

    function frame(now) {
      running = false;
      if (!visible) return;
      var act = steps[cur] ? steps[cur].dataset.act : 'charge';
      var T = TARGET[act] || TARGET.charge;
      var k = 0.085;
      var tgtRy = T.ry + (T.spin ? (now - t0) / 4000 : (local - 0.5) * 0.35);
      var tx = mobile ? 0 : T.x;
      ['ry', 'lid', 'buds', 'x', 'y', 'ledA', 'btn'].forEach(function (p) {
        var goal = p === 'ry' ? tgtRy : p === 'x' ? tx : p === 'y' ? (T.y || 0) * (mobile ? 1.15 : 1) : p === 'ledA' ? T.ledA : T[p] || 0;
        var d = goal - S[p];
        if (Math.abs(d) > 0.0005) S[p] += d * k; else S[p] = goal;
      });
      rig.rotation.y = S.ry;
      rig.position.x = S.x;
      rig.position.y = S.y + Math.sin(now / 1400) * 0.05;
      lidPivot.rotation.x = lerp(LID_CLOSED, 0, S.lid);
      var y = lerp(-1.45, 0, S.buds);
      budL.position.set(budL0.x, budL0.y + y, budL0.z + lerp(-0.18, 0, S.buds));
      budR.position.set(budR0.x, budR0.y + y, budR0.z + lerp(-0.18, 0, S.buds));
      budL.visible = budR.visible = S.lid > 0.55 && (S.buds > 0.25 || Math.cos(S.ry) > 0.2);
      var pulse = T.flash ? (0.55 + 0.45 * Math.sin(now / 180)) : 1;
      var col = T.led;
      if (T.amber) col = local < 0.6 ? [1, 0.7, 0.2] : [1, 1, 1];
      led.material.color.setRGB(col[0], col[1], col[2]);
      led.material.opacity = S.ledA * pulse;
      btn.material.opacity = S.btn * (0.6 + 0.4 * Math.sin(now / 260));
      renderer.render(scene, camera);
      schedule();
    }
    function schedule() { if (!running && visible) { running = true; requestAnimationFrame(frame); } }
    threeTick = schedule;
    new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) schedule(); }).observe(stage);
    window.addEventListener('resize', function () { resize(); schedule(); });
    resize();
    root.classList.add('sxs--3d');
    schedule();
  }
})();
